var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "IndexForm",
    { attrs: { "is-whitelabel": _vm.isWhitelabel } },
    [
      _vm.prpDetails
        ? _c("PublisherRegistrationPageForm", {
            attrs: {
              "action-status": _vm.actionStatus,
              "prp-details": _vm.prpDetails
            },
            on: { "on-register": _vm.onSubmit }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.prpDetails
        ? _c("OpenRegistrationPageError", {
            attrs: { "applicant-type": "publisher" }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }